import { useContext } from "react";
import { NumberOfferContext } from "../../../App";
import { ICart } from "../ICart";
import { getResponseToState, ICartResponse } from "@mappers/getCartMapper";
import { useFetch } from "@hooks/useFetch";
import { portinRoute } from "@api-routes/eirSalesFacade";
import { getCartItemsNumber } from "@utils/getCartItemsNumber";

export const useDeletePortin = () => {
    const [deletePortinState, { deleteCall }] = useFetch();
    const { setNumberOfferSelected } = useContext(NumberOfferContext);

    const deletePortin = (cartOfferId: number): Promise<ICart | undefined> => {
        return deleteCall<ICartResponse>(portinRoute(cartOfferId), {}).then((newCartResponse) => {
            if (newCartResponse) {
                const newCart = getResponseToState(newCartResponse);

                setNumberOfferSelected(getCartItemsNumber(newCart));

                return newCart;
            }

            return undefined;
        });
    };

    return { deletePortinState, deletePortin };
};
